import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    date: {
        id: '_.modal.loan_builder.repayment_schedule.table.date',
        defaultMessage: 'Date'
    },
    split: {
        id: '_.modal.loan_builder.repayment_schedule.table.split',
        defaultMessage: 'Split'
    },
    principal: {
        id: '_.modal.loan_builder.repayment_schedule.table.principal',
        defaultMessage: 'Principal'
    },
    interest: {
        id: '_.modal.loan_builder.repayment_schedule.table.interest',
        defaultMessage: 'Interest'
    },
    totalRepayment: {
        id: '_.modal.loan_builder.repayment_schedule.table.totalRepayment',
        defaultMessage: 'Total Repayment'
    },
    fees: {
        id: '_.modal.loan_builder.repayment_schedule.table.fees',
        defaultMessage: 'Fees'
    },
    total: {
        id: '_.modal.loan_builder.repayment_schedule.table.total',
        defaultMessage: 'Total'
    },
    payOff: {
        id: '_.modal.loan_builder.repayment_schedule.table.pay_off',
        defaultMessage:
            'To pay off your loan early, just make a bank transfer or a one-off payment in your iwoca account.'
    },
    extraPayments: {
        id: '_.modal.loan_builder.repayment_schedule.table.extra_payments',
        defaultMessage:
            'You can also make extra payments throughout to bring your outstanding amount down.'
    }
});
